<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10">
    <path
      d="M.303.3c-.192.192-.3.452-.302.73a.998.998 0 0 0 .302.756L3.506 5 .303 8.212c-.192.194-.3.453-.302.73v.01c0 .28.106.543.3.744.388.404 1.04.407 1.458.003l3.938-3.962c.195-.195.302-.456.302-.72.002-.037 0-.036 0-.053a.991.991 0 0 0-.303-.703L1.748.3C1.349-.1.7-.1.303.3"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
